export default function calcPercantage(total, iva) {
  const result = Number((total * Number(iva)) / 100).toFixed(0);
  return Number(result);
}
